import { interpolate } from "../../../api/helpers/stringHelper";
import { itemQuantity } from "../../../api/helpers/shoppingCartHelper.js";
import { $$ } from "./../../OO_jquery";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["cartItems", "applicableLoyalityRule"]),
    getRollIntoPoints() {
      if (this.applicableLoyalityRule) {
        if (this.selectedRollIntoModiefiers.length == 0)
          return Math.floor(
            this.showRollIntoProduct.FixedPriceValue *
              this.applicableLoyalityRule.pointPerDollar
          );
        else
          return Math.floor(
            this.rollIntoPrice * this.applicableLoyalityRule.pointPerDollar
          );
      } else return null;
    },
    cartQuantity() {
      var item = { id: this.productId };
      const iq = itemQuantity(item, this.getModifiers(), this.cartItems);
      return iq + this.quantity;
    },
    isIos() {
      return !!navigator.platform.match(/iPhone|iPod|iPad/);
    },
    maxQuantity() {
      var item = { id: this.category.ProductID || this.productId };
      const iq = itemQuantity(item, this.getModifiers(), this.cartItems);
      return this.maxItemQuantity - iq;
    },
    isDisabledAddCards() {
      return (
        this.cartQuantity > this.maxItemQuantity || !this.IsModifierRuleValided
      );
    }
  },
  methods: {
    fixQuantity(group, checked, md, groupID) {
      if (md && group) {
        if (checked) {
          if (group.IsSingleSel) {
            group.Modifiers.forEach(function(item) {
              item.quantity = 0;
              item.IsSelected = false;
            });
            this.ModifierGroupsStates.filter(p => p.GroupId == groupID).forEach(
              state => {
                (state.quantity = 0), (state.IsSelected = false);
              }
            );
          }
          if (!md.quantity || md.quantity == 0) {
            md.quantity = 1;
            md.IsSelected = true;
          }
        } else {
          md.quantity = 0;
          md.IsSelected = false;
        }
        var state = this.ModifierGroupsStates.filter(
          p => p.GroupId == groupID && p.MID == md.ID
        )[0];
        if (state) {
          (state.quantity = md.quantity), (state.IsSelected = md.IsSelected);
        } else {
          state = {
            GroupId: groupID,
            MID: md.ID,
            quantity: md.quantity,
            IsSelected: md.IsSelected
          };
          this.ModifierGroupsStates.push(state);
        }
      }
      this.$forceUpdate();
    },

    decMdQty(md, groupID) {
      var state = this.ModifierGroupsStates.filter(
        p => p.GroupId == groupID && p.MID == md.ID
      )[0];
      md.quantity = md.quantity || 0;
      if (md.quantity == md.MinQty) md.quantity = 0;
      else md.quantity--;
      if (state) {
        state.quantity = md.quantity;
      } else {
        state = { GroupId: groupID, MID: md.ID, quantity: md.quantity };
        this.ModifierGroupsStates.push(state);
      }
      this.$forceUpdate();
    },
    incMdQty(md, group, groupID) {
      var state = this.ModifierGroupsStates.filter(
        p => p.GroupId == groupID && p.MID == md.ID
      )[0];
      if (group.IsSingleSel) {
        group.Modifiers.filter(m => m.ID != md.ID).forEach(m => {
          (m.IsSelected = false), (m.quantity = 0);
        });
        this.ModifierGroupsStates.filter(
          p => p.GroupId == groupID && p.MID != md.ID
        ).forEach(m => {
          (m.IsSelected = false), (m.quantity = 0);
        });
      }
      md.quantity = md.quantity || 0;
      if (md.quantity == 0 && md.MinQty > 0) {
        md.quantity = md.MinQty;
      } else md.quantity += 1;
      if (state) {
        state.quantity = md.quantity;
      } else {
        state = { GroupId: groupID, MID: md.ID, quantity: md.quantity };
        this.ModifierGroupsStates.push(state);
      }
      this.$forceUpdate();
    },
    getModifiers() {
      var selectedModifiers = [];
      this.ModifierGroupsStates.filter(p => p.quantity > 0).forEach(state => {
        var that = this;
        selectedModifiers.push({
          ...that.modifiers[state.GroupId].Modifiers.filter(
            p => p.ID == state.MID
          )[0]
        });
      });
      return selectedModifiers;
    },
    rollToProduct() {
      if (this.isIos)
        this.$nextTick(() => {
          const bodyScrollLock = require("body-scroll-lock");
          const targetElement = $$(".submodifier-scroll");
          for (var i = 0; i < targetElement.length; i++) {
            bodyScrollLock.enableBodyScroll(targetElement[i]);
          }
        });
      this.$emit("updated", this.getModifiers(), this.rollintoIndex);
    },
    cancelModifiers() {
      if (this.isIos)
        this.$nextTick(() => {
          const bodyScrollLock = require("body-scroll-lock");
          const targetElement = $$(".submodifier-scroll");
          for (var i = 0; i < targetElement.length; i++) {
            bodyScrollLock.enableBodyScroll(targetElement[i]);
          }
        });
      this.$emit("canceled");
    },
    getSelectedValue(groupID, MId) {
      var state = this.ModifierGroupsStates.filter(
        p => p.GroupId == groupID && p.MID == MId
      )[0];
      if (state) return state.IsSelected;
      else return false;
    },
    initModifiers() {
      try {
        var intitState = this.initialModifiers;
        this.ModifierGroupsStates.splice(0, this.ModifierGroupsStates.length);
        for (var group of this.product.ModifierGroups) {
          var groupInfo = this.modifiers[group];
          if (this.isComboItem(groupInfo) && !this.isMobile()) continue;
          if (groupInfo)
            for (var modifier of groupInfo.Modifiers) {
              modifier.MaxQty = modifier.MaxQty || 20;
              modifier.MinQty = groupInfo.IncludeQuantity
                ? modifier.MinQty || 1
                : 1;
              if (modifier.MaxQty < modifier.MinQty)
                modifier.MaxQty = modifier.MinQty;
              var initQuantity = 0;
              var isSelected = false;
              if (intitState) {
                groupInfo.selectionCount = 0;
                var find = intitState.find(md => md.ID == modifier.ID);
                if (find) {
                  this.ModifierGroupsStates.push({
                    GroupId: group,
                    MID: modifier.ID,
                    quantity: find.quantity,
                    IsSelected: find.IsSelected
                  });
                  modifier.quantity = find.quantity;
                  modifier.IsSelected = find.IsSelected;
                  initQuantity = find.quantity;
                  isSelected = find.IsSelected;
                  groupInfo.selectionCount += modifier.quantity;
                }
              }
              Object.defineProperty(modifier, "quantity", {
                enumerable: true,
                writable: true,
                value: initQuantity
              });
              Object.defineProperty(modifier, "IsSelected", {
                enumerable: true,
                writable: true,
                value: isSelected
              });
            }
        }
        this.autoSelectModifiers();
        this.forceSelectModifiers();
      } catch (e) {
        console.log(e);
      }
    },
    checkRule() {
      let modifierErrorMsgs = [];
      this.IsModifierRuleValided = true;
      for (var groupID of this.product.ModifierGroups) {
        var modifierOption = this.modifiers[groupID];
        if (!modifierOption) continue;
        if (modifierOption.Modifiers && modifierOption.Modifiers.length == 0)
          continue;
        let minSelection = modifierOption.MinimumSelection || 0;
        if (modifierOption.IsForceSel && minSelection) {
          var selectedItemInGroup = 0;
          this.ModifierGroupsStates.filter(
            p => p.GroupId == groupID && p.quantity > 0
          ).forEach(state => {
            selectedItemInGroup += state.quantity;
          });
          if (
            selectedItemInGroup < minSelection &&
            !modifierOption.IsSingleSel
          ) {
            this.IsModifierRuleValided = false;
            let msg =
              "Minimum selection of " +
              (modifierOption.Name || "Modifiers ") +
              " is " +
              minSelection;
            if (minSelection < 2) {
              modifierErrorMsgs.push(msg + " item.");
            } else {
              modifierErrorMsgs.push(msg + " items.");
            }
          }
        }
      }
      return modifierErrorMsgs;
    },
    autoSelectModifiers() {
      try {
        for (var groupID of this.product.ModifierGroups) {
          // if group configure as Auto Select
          var group = this.modifiers[groupID];
          if (
            group &&
            group.IsAutoSel &&
            !(this.initialModifiers && this.initialModifiers.length > 0)
          ) {
            // if MaximumSelection not configured set as all
            // group.MaximumSelection =
            //   group.MaximumSelection || group.Modifiers.length;
            group.selectionCount = this.ModifierGroupsStates.filter(
              p => p.GroupId == groupID && p.quantity > 0
            ).length;
            for (const [index, modifier] of group.Modifiers.entries()) {
              if (
                (!group.MaximumSelection &&
                  (group.IsSingleSel ? index == 0 : true)) ||
                (group.MaximumSelection >=
                  group.selectionCount + modifier.MinQty &&
                  (group.IsSingleSel ? index == 0 : true))
              ) {
                this.ModifierGroupsStates.push({
                  GroupId: groupID,
                  MID: modifier.ID,
                  quantity: modifier.MinQty || 1,
                  IsSelected: true
                });
                modifier.quantity = modifier.MinQty || 1;
                modifier.IsSelected = true;
                group.selectionCount += modifier.quantity;
              }
            }
          }
        }
      } catch (e) {
        alert(e);
      }
    },
    forceSelectModifiers() {
      for (var groupID of this.product.ModifierGroups) {
        // if group configure as Auto Select
        var group = this.modifiers[groupID];
        // if group configure as Force Select
        if (group && group.IsForceSel) {
          group.selectionCount = this.ModifierGroupsStates.filter(
            p => p.GroupId == groupID && p.quantity > 0
          ).length;
          for (var modifier of group.Modifiers.filter(
            md => (md.quantity || 0) == 0
          )) {
            // if MinimumSelection do not done before
            if (
              (group.MinimumSelection || 1) >=
              group.selectionCount + modifier.MinQty
            ) {
              this.ModifierGroupsStates.push({
                GroupId: groupID,
                MID: modifier.ID,
                quantity: modifier.MinQty,
                IsSelected: true
              });
              modifier.quantity = modifier.MinQty;
              modifier.IsSelected = true;
              group.selectionCount += modifier.MinQty;
              if (
                (group.MinimumSelection || 1) <= group.selectionCount ||
                group.IsSingleSel
              )
                break;
            }
          }
        }
      }
    },
    checkMaximumSelection() {
      for (var groupID of this.product.ModifierGroups) {
        // if group configure as Auto Select
        var group = this.modifiers[groupID];
        if (group) {
          var selectionCount = 0;
          this.ModifierGroupsStates.filter(
            p => p.GroupId == groupID && p.quantity > 0
          ).forEach(state => {
            selectionCount += state.quantity;
          });
          group.selectionCount = selectionCount;
          if (
            group.MaximumSelection &&
            selectionCount >= group.MaximumSelection
          ) {
            group.MaximumDisable = true;
          } else {
            group.MaximumDisable = false;
          }
        }
      }
    },
    checkMinimumSelection() {
      for (var groupID of this.product.ModifierGroups) {
        // if group configure as Auto Select
        var group = this.modifiers[groupID];
        if (group && group.IsForceSel) {
          var selectionCount = 0;
          this.ModifierGroupsStates.filter(
            p => p.GroupId == groupID && p.quantity > 0
          ).forEach(state => {
            selectionCount += state.quantity;
          });
          group.selectionCount = selectionCount;
          group.MinimumSelection = group.MinimumSelection || 1;
          if (selectionCount <= group.MinimumSelection) {
            group.MinimumDisable = true;
          } else {
            group.MinimumDisable = false;
          }
        }
      }
    },
    IsDisableIncreament(md, group) {
      return (
        md.MaxQty <= md.quantity ||
        (!(group.IsSingleSel && (md.quantity || 0) == 0) &&
          group.MaximumDisable) ||
        (md.quantity == 0 &&
          !group.IsSingleSel &&
          group.selectionCount + md.MinQty > group.MaximumSelection &&
          group.MaximumSelection)
      );
    },
    IsDisableDecreament(md, group) {
      return (
        md.quantity == 0 ||
        (group.MaximumDisable && (md.quantity || 0) == 0) ||
        group.MinimumDisable ||
        (group.IsForceSel &&
          md.quantity == md.MinQty &&
          group.selectionCount - md.MinQty < group.MinimumSelection)
      );
    },
    groupSpecification(group) {
      if (group.IsForceSel && group.MaximumSelection) {
        return interpolate(
          `Select {0} to {1} :`,
          group.MinimumSelection || 1,
          group.MaximumSelection
        );
      } else if (group.MaximumSelection) {
        return interpolate(`Select up to {0} :`, group.MaximumSelection);
      } else if (group.IsForceSel) {
        return interpolate(
          `Select at least {0} :`,
          group.MinimumSelection || 1
        );
      }
    },
    hasSubmodifier(modifier) {
      return modifier.LinkedProductID;
    },
    computePrice(modifier) {
      var sum = modifier.Price;
      if (modifier.selectedSubmodifiers) {
        modifier.selectedSubmodifiers.forEach(element => {
          sum += element.Price;
        });
      }
      return sum;
    },
    isComboItem(group) {
      for (var modifier of group.Modifiers) {
        if (modifier.LinkedProductID) {
          return true;
        }
      }
      return false;
    }
  }
};
